// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule, MatCheckbox, MatFormFieldModule, MatCheckboxModule } from '@angular/material';
import { Login2Component } from './login2/login2.component';
import { Login2Service } from './login2/login2.service';
import { TokenAuthServiceProxy, SessionServiceProxy } from '../../../shared/service-proxies/service-proxies';
import { UtilsService } from 'abp-ng2-module/dist/src/utils/utils.service';
import { TokenService } from 'abp-ng2-module/dist/src/auth/token.service';
import { MessageService } from 'abp-ng2-module/dist/src/message/message.service';
import { LogService } from 'abp-ng2-module/dist/src/log/log.service';
import { AppSessionService } from '../../../shared/session/app-session.service';
import { Test1Service } from './login2/test1.service';
import { LoginRouterComponent } from './login-router/login-router.component';
import { SharedModule } from '../../../shared/shared.module';
import { PhotoDirective } from './transpop/shared/directives/photo.directive';



@NgModule({
	declarations: [Login2Component, LoginRouterComponent],
	exports: [],
	imports: [


	CommonModule,
		HttpClientModule,
		FormsModule,
		CoreModule,
		//TranspopModule,
		PartialsModule,
		//MailModule,
		//ECommerceModule,
		//UserManagementModule,

		MatButtonModule,
		MatInputModule,
		MatCheckboxModule,
		MatFormFieldModule,
		
		PartialsModule,
		SharedModule,

		
	],
	providers: [
		Login2Service, 
		TokenAuthServiceProxy, 
		SessionServiceProxy,
		UtilsService, 
		TokenService, 
		MessageService, 
		LogService, 
		AppSessionService,
		Test1Service
	]
})
export class PagesModule {
}
